import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import { Group, GroupOptionsOverview } from '../../graphql/groups.datatypes';
import {gqlGroupMember, gqlGroupOption} from './getGroupMember.api';

export interface GroupData {
    groupByRef: void
    group: Group
}

export const getGroupQuery = (query: string) => {
    return gql`
        query getGroup($id: Int!){
            group(id: $id){
                ${query}
            }
        }
    `;
}

export const getGroupWithQuery = (groupId: number | null, query: string) => {
    const id = groupId ? groupId : -1;
    return useQuery<GroupData>(
        getGroupQuery(query),
        {
            variables: {id},
        }
    );
};

interface GroupOverviewData {
    groupByRef: void
    getGroupOverview: Group
}

export const getGroupOverviewQuery = (groupId: number | null, query: string) => {
    const id = groupId ? groupId : -1;
    return useQuery<GroupOverviewData>(
        gql`
            query getGroupOverview($id: Int!){
                getGroupOverview(id: $id){
                    ${query}
                }
            }
        `,
        {
            variables: {id}
        }
    );
};

export default getGroupWithQuery;
